import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {string?} State */
const initialState = null;

const selectOne = (_, { payload: predefinedMessageId }) => predefinedMessageId;

export default createReducer(initialState, {
  [types.SELECT_ID]: selectOne,
});
